enum KeyboardKey {
  Comma = "Comma",
  Enter = "Enter",
  Space = "Space",
  Tab = "Tab",
}

export default KeyboardKey;
